import React from 'react';
import type { ComponentType } from 'react';
import { Link, type LoaderFunction } from 'react-router-dom';
import type { MenuProps } from 'antd';

import {
  AppstoreOutlined,
  FileDoneOutlined,
  BarChartOutlined,
  FileTextOutlined,
  CarOutlined,
  ShoppingOutlined,
  CalendarOutlined,
  RollbackOutlined,
  CheckSquareOutlined,
  ThunderboltOutlined,
  TagsOutlined,
  InboxOutlined,
  BookOutlined,
  CalculatorOutlined,
  SettingOutlined,
  CloudUploadOutlined,
  BellOutlined,
  SoundOutlined,
  ToolOutlined,
  CrownOutlined,
  ApiOutlined,
  WarningOutlined,
  DashboardOutlined,
  FundProjectionScreenOutlined,
  SwapOutlined,
  ShopOutlined,
  LinkOutlined,
} from '@ant-design/icons';
import { Tooltip } from 'antd';
import styled from 'styled-components';

// Products pages
// Inbounds pages
// Contact Address pages
// Consumables pages
// Orders pages
// Shipments pages

// Shelves pages

// ShelfMovements pages

// Return Orders pages

// Processing Orders pages

// Brands pages

// ProductCategories pages

// Inventory pages

// PickingList pages

// QC pages

// Merchants pages

// Return Order Verification pages

// Operations pages
// Out of Stock Products pages
// Dashboard page
// Account Settings pages
import OperatorsEdit from '@pages/operator/Operators/Edit';
import OperatorsList from '@pages/operator/Operators/List';
import OperatorsNew from '@pages/operator/Operators/New';
import OperatorsMerchants from '@pages/operator/Operators/Merchants';
import OrganizationSettings from '@pages/operator/OrganizationSettings';
import ProfileShow from '@pages/operator/Profile/Show';
import WarehousesList from '@pages/operator/Warehouses/List';
import WarehouseNew from '@pages/operator/Warehouses/New';
import WarehouseShow from '@pages/operator/Warehouses/Show';
import { List as BrandsList, Show as BrandsShow, New as BrandsNew } from '@pages/operator/Brands';
import { List as ShelfTypesList, Show as ShelfTypesShow } from '@pages/operator/ShelfTypes';
import { BundlesList, BundlesShow, BundlesEdit } from '@pages/operator/Bundles';
import OperatorBundleNew from '@pages/operator/Bundles/New';
import ConsumablesEdit from '@pages/operator/Consumables/Edit';
import OperatorConsumableNew from '@pages/operator/Consumables/New';
import ConsumablesList from '@pages/operator/Consumables/List';
import ConsumablesShow from '@pages/operator/Consumables/Show';
import ContactAddressEdit from '@pages/operator/ContactAddresses/Edit';
import ContactAddressList from '@pages/operator/ContactAddresses/List';
import ContactAddressShow from '@pages/operator/ContactAddresses/Show';
import OperatorContactAddressNew from '@pages/operator/ContactAddresses/New';
import Dashboard from '@pages/operator/Dashboard';
import { FlexibleProductsList, FlexibleProductsShow, FlexibleProductsEdit } from '@pages/operator/FlexibleProducts';
import OperatorFlexibleProductNew from '@pages/operator/FlexibleProducts/New';
// Imports pages
import ImportsList from '@pages/operator/Imports/List';
import ImportShow from '@pages/operator/Imports/Show';
import { List as InboundsList, Show as InboundsShow, Edit as InboundsEdit } from '@pages/operator/Inbounds';
import OperatorInboundNew from '@pages/operator/Inbounds/New';
import InboundAcceptance from '@pages/operator/Inbounds/Acceptance';
import ReceiptPutaway from '@pages/operator/Receipts/Putaway';
import { List as SuppliersList, Show as SuppliersShow, Edit as SuppliersEdit } from '@pages/operator/Suppliers';
import OperatorSupplierNew from '@pages/operator/Suppliers/New';
import { List as PurchaseOrdersList, Show as PurchaseOrdersShow, Edit as PurchaseOrdersEdit } from '@pages/operator/PurchaseOrders';
import OperatorPurchaseOrderNew from '@pages/operator/PurchaseOrders/New';
import OperatorInventoriesList from '@pages/operator/Inventories/List';
import OperatorInventoryOrders from '@pages/operator/Inventories/Orders';
import OperatorInventoryMovementsList from '@pages/operator/InventoryMovements/List';
import OperatorInventoryMonitorsList from '@pages/operator/InventoryMonitors/List';
import OperatorInventoryMonitorsEdit from '@pages/operator/InventoryMonitors/Edit';
import OperatorInventoryMonitorNew from '@pages/operator/InventoryMonitors/New';
import OperatorInventoryMonitorsShow from '@pages/operator/InventoryMonitors/Show';
// Inventory Types pages
import OperatorInventoryTypesList from '@pages/operator/InventoryTypes/List';
// Merchant Inventory Types pages
// Shipping Accounts pages
// Merchant Channels pages
// Stock Takings pages
// Notifications pages
import OperatorNotificationList from '@pages/operator/Notifications/List';
import OperatorNotificationShow from '@pages/operator/Notifications/Show';
// Warehouse Broadcasts pages
import WarehouseBroadcastsList from '@pages/operator/WarehouseBroadcasts/List';
import Distribute from '@pages/operator/Operations/Distribute';
import InboundAcceptanceLanding from '@pages/operator/Operations/InboundAcceptanceLanding';
import OrderReports from '@pages/operator/Reports/Orders';
import SlottingAnalysis from '@pages/operator/Reports/SlottingAnalysis';
import { WorkforceStatsDailySummary, WorkforceStatsOperatorPerformance } from '@pages/operator/WorkforceStats';
import OrderEdit from '@pages/operator/Orders/Edit';
import OrdersList from '@pages/operator/Orders/List';
import OperatorFulfillmentMerge from '@pages/operator/Fulfillments/Merge';
import OrderNew from '@pages/operator/Orders/New';
import OrderShow from '@pages/operator/Orders/Show';
import SerialNumbersList from '@pages/operator/Orders/SerialNumbers/List';
import OperatorOrderHoldsList from '@pages/operator/OrderHolds/List';
import OperatorInventoryHoldsList from '@pages/operator/InventoryHolds/List';
import OperatorInventoryHoldsNew from '@pages/operator/InventoryHolds/New';
import OperatorInventoryHoldsShow from '@pages/operator/InventoryHolds/Show';
import OperatorUploadLabels from '@pages/operator/Orders/UploadLabels';
import OperatorOrderTemplateEdit from '@pages/operator/OrderTemplates/Edit';
import OperatorOrderTemplateNew from '@pages/operator/OrderTemplates/New';
import OperatorOrderTemplatesList from '@pages/operator/OrderTemplates/List';
import OperatorOrderTemplateShow from '@pages/operator/OrderTemplates/Show';
import OperatorOutOfStockProductsList from '@pages/operator/OutOfStockProducts/List';
import CreatePickingList from '@pages/operator/PickingLists/Create';
import PickingListsList from '@pages/operator/PickingLists/List';
import ResidualTotes from '@pages/operator/PickingLists/ResidualTotes';
import OperatorPickingListPresetList from '@pages/operator/PickingListPresets/List';
import OperatorPickingListPresetNew from '@pages/operator/PickingListPresets/New';
import OperatorPickingListPresetEdit from '@pages/operator/PickingListPresets/Edit';
import PickingListShow from '@pages/operator/PickingLists/Show';
import PickingListConfirm from '@pages/operator/PickingLists/Confirm';
import PickingWaveShow from '@pages/operator/PickingWaves/Show';
import OperatorProductionBomEdit from '@pages/operator/ProductionBoms/Edit';
import OperatorProductionBomNew from '@pages/operator/ProductionBoms/New';
import OperatorProductionBomsList from '@pages/operator/ProductionBoms/List';
import OperatorProductionBomShow from '@pages/operator/ProductionBoms/Show';
import ProductCategoriesList from '@pages/operator/ProductCategories/List';
import ProductCategoryNew from '@pages/operator/ProductCategories/New';
import ProductCategoryShow from '@pages/operator/ProductCategories/Show';
import OperatorProductLabelTemplateEdit from '@pages/operator/ProductLabelTemplates/Edit';
import OperatorProductLabelTemplateNew from '@pages/operator/ProductLabelTemplates/New';
import OperatorProductLabelTemplatesList from '@pages/operator/ProductLabelTemplates/List';
import OperatorProductLabelTemplateShow from '@pages/operator/ProductLabelTemplates/Show';
import ProductEdit from '@pages/operator/Products/Edit';
import OperatorProductNew from '@pages/operator/Products/New';
import ProductInventory from '@pages/operator/Products/Inventory';
import ProductsList from '@pages/operator/Products/List';
import ReplaceSku from '@pages/operator/Products/ReplaceSku';
import ProductShow from '@pages/operator/Products/Show';
import OperatorProductSerialNumbersList from '@pages/operator/ProductSerialNumbers/List';
import QcIndex from '@pages/operator/Qc/Index';
import ReturnOrderCollect from '@pages/operator/ReturnOrders/Collect';
import ReturnOrderEdit from '@pages/operator/ReturnOrders/Edit';
import OperatorReturnOrderNew from '@pages/operator/ReturnOrders/New';
import ReturnReceiptPendingConvert from '@pages/operator/ReturnReceipts/PendingConvert';
import ReturnReceiptShow from '@pages/operator/ReturnReceipts/Show';
import ReturnOrdersList from '@pages/operator/ReturnOrders/List';
import ReturnOrderShow from '@pages/operator/ReturnOrders/Show';
import ReturnOrderVerificationIndex from '@pages/operator/ReturnOrderVerification/Index';
import OperatorShelfMovementsList from '@pages/operator/ShelfMovements/List';
import ShelvesBatchNew from '@pages/operator/Shelves/BatchNew';
import ShelvesList from '@pages/operator/Shelves/List';
import ShelvesShow from '@pages/operator/Shelves/Show';
import OperatorShippingAccountsList from '@pages/operator/ShippingAccounts/List';
import ShippingRateCardsList from '@pages/operator/ShippingRateCards/List';
import ShippingRateCardsEdit from '@pages/operator/ShippingRateCards/Edit';
import OperatorShippingRateCardNew from '@pages/operator/ShippingRateCards/New';
import OperatorShippingTypesList from '@pages/operator/ShippingTypes/List';
import ShipmentsList from '@pages/operator/Shipments/List';
import OperatorSalesChannelsEdit from '@pages/operator/SalesChannels/Edit';
import OperatorSalesChannelsList from '@pages/operator/SalesChannels/List';
import OperatorSalesChannelsNew from '@pages/operator/SalesChannels/New';
import OperatorSalesChannelsShow from '@pages/operator/SalesChannels/Show';
import { OperatorEcAccountsList, OperatorEcAccountEdit, OperatorEcAccountShow } from '@pages/operator/EcAccounts';
import OperatorEcAccountNew from '@pages/operator/EcAccounts/New';
import OperatorMerchantInventoryTypesList from '@pages/operator/MerchantInventoryTypes/List';
import OperatorMerchantShippingTypesList from '@pages/operator/MerchantShippingTypes/List';
import MerchantsList from '@pages/operator/Merchants/List';
import MerchantNew from '@pages/operator/Merchants/New';
import MyMerchant from '@pages/operator/Merchants/My';
import MerchantShow from '@pages/operator/Merchants/Show';
// Billings pages
import BillingsList from '@pages/operator/Billings/List';
import BillingsShow from '@pages/operator/Billings/Show';
// Sluggish Products pages
import OperatorSluggishProductsIndex from '@pages/operator/SluggishProducts/Index';
import OperatorInventorySnapshotsList from '@pages/operator/InventorySnapshots/List';
import OperatorLocationSnapshotsList from '@pages/operator/LocationSnapshots/List';
import StockAdjustmentsList from '@pages/operator/StockAdjustments/List';
import StockAdjustmentNew from '@pages/operator/StockAdjustments/New';
import StockAdjustmentEdit from '@pages/operator/StockAdjustments/Edit';
import StockAdjustmentShow from '@pages/operator/StockAdjustments/Show';
import InventoryTransformationsList from '@pages/operator/InventoryTransformations/List';
import InventoryTransformationNew from '@pages/operator/InventoryTransformations/New';
import InventoryTransformationEdit from '@pages/operator/InventoryTransformations/Edit';
import InventoryTransformationShow from '@pages/operator/InventoryTransformations/Show';
import OperatorInventoryTypeReclassifyRulesList from '@pages/operator/InventoryTypeReclassifyRules/List';
import StockTakingsList from '@pages/operator/StockTakings/List';
import StockTakingShow from '@pages/operator/StockTakings/Show';
import StockTakingNew from '@pages/operator/StockTakings/New';
import StockTakingShelfEdit from '@pages/operator/StockTakings/ShelfEdit';
import OperatorUnknownProductsList from '@pages/operator/UnknownProducts/List';
import OperatorUnknownProductShow from '@pages/operator/UnknownProducts/Show';
import OperatorPickingMovementsList from '@pages/operator/PickingMovements/List';
import OperatorAccessibleIpAddressesList from '@pages/operator/AccessibleIpAddresses/List';
import OperatorWebhookDeliveriesList from '@pages/operator/WebhookDeliveries/List';
import OperatorThirdPartyApiLogsList from '@pages/operator/ThirdPartyApiLogs/List';
import OperatorThirdPartyApiLogsShow from '@pages/operator/ThirdPartyApiLogs/Show';
import OperatorAiAuditLogsList from '@pages/operator/AiAuditLogs/List';
import { ValueAddedServicesList } from '@pages/operator/ValueAddedServices';
import HolidaysList from '@pages/operator/Holidays/List';
import { GovernanceSubscription, GovernancePricingPlans, GovernancePaymentMethods, GovernanceInvoices, GovernanceBillingProfile, GovernancePcsLedger, GovernanceAiUsage } from '@pages/operator/Governance';

import operatorApiFetch from '@services/operator/apiService';

import FulfillmentsList from '@pages/operator/Fulfillments/List';

import FulfillmentShow from '@pages/operator/Fulfillments/Show';

import StockTransferOrdersList from '@pages/operator/StockTransferOrders/List';
import StockTransferOrderShow from '@pages/operator/StockTransferOrders/Show';
import StockTransferOrderNew from '@pages/operator/StockTransferOrders/New';
import StockTransferOrderEdit from '@pages/operator/StockTransferOrders/Edit';
import ReplenishmentOrdersList from '@pages/operator/ReplenishmentOrders/List';
import ReplenishmentOrderShow from '@pages/operator/ReplenishmentOrders/Show';
import ReplenishmentNeeds from '@pages/operator/Replenishment/Needs';
import ReplenishmentShelvesList from '@pages/operator/ReplenishmentShelves/List';
import ReplenishmentShelvesNew from '@pages/operator/ReplenishmentShelves/New';
import ReplenishmentShelvesEdit from '@pages/operator/ReplenishmentShelves/Edit';
import WorkOrdersList from '@pages/operator/Production/WorkOrders/List';
import WorkOrderNew from '@pages/operator/Production/WorkOrders/New';
import WorkOrderEdit from '@pages/operator/Production/WorkOrders/Edit';
import WorkOrderShow from '@pages/operator/Production/WorkOrders/Show';
import MaterialPickingList from '@pages/operator/Production/MaterialPicking/List';

// Fulfillment Dashboard (看板)
import { FulfillmentWall } from '@pages/operator/FulfillmentDashboard';
import { PickingWall } from '@pages/operator/PickingDashboard';
import { InboundWall } from '@pages/operator/InboundDashboard';
import { CarrierWall } from '@pages/operator/CarrierDashboard';
import { ExceptionWall } from '@pages/operator/ExceptionDashboard';

// ==================== 選單配置 ====================

// 選單分區常數
export const MENU_SECTIONS = {
  OPERATIONS: 'operations', // 作業區 (入庫、出庫、作業)
  INVENTORY: 'inventory',   // 庫存區 (庫存管理、庫存報表、生產管理)
  MONITOR: 'monitor',       // 看板區 (即時監控)
  REPORTS: 'reports',       // 報表區
  DATA: 'data',             // 基礎資料 (商品、客戶)
  ADVANCED: 'advanced',     // 進階設定
} as const;

export type MenuSection = typeof MENU_SECTIONS[keyof typeof MENU_SECTIONS];

// 'resource:action' literal — 與 <Can> / <CanShow> / generated Permission 一致。
// TODO: 收緊為 `Permission` 一旦 config/permissions.yml 涵蓋所有 menu 用到的 scope
// (目前 menu 用到 merchants:read / inventory_holds:read / shipments:read / stock_*:read
//  / warehouses:read / brands:read，但 manifest 還沒生這些)。
export type RequiredPermission = string;

export interface MenuItem {
  key: string;
  labelKey: string;
  icon?: ComponentType<any>;
  path: string;
  isParent?: boolean;
  section?: MenuSection;
  component?: ComponentType<any>;
  requiredPermission?: RequiredPermission;
  requiredFeature?: string;
  hideInStandard?: boolean;
  onlyInStandard?: boolean;
  hideInEnterprise?: boolean;
  hiddenWhenStorageMode?: string[];
  children?: MenuItem[];
}

export interface RouteEntry {
  path: string;
  component: ComponentType<any>;
  componentProps?: Record<string, unknown>;
  loader?: LoaderFunction;
  requiredPermission?: RequiredPermission;
  requiredFeature?: string;
  hideInStandard?: boolean;
  onlyInStandard?: boolean;
  hideInEnterprise?: boolean;
}

export interface MenuMetaEntry {
  path: string;
  parentKey?: string;
  labelKey?: string;
  external: boolean;
}

interface VisibilityContext {
  permissions?: string[];
  enabledFeatures?: string[];
  isStandard?: boolean;
  isEnterprise?: boolean;
  storageMode?: string;
}

type TFunction = (key: string) => string;

type AntdMenuItems = NonNullable<MenuProps['items']>;

const MenuLabel = styled.span`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`;

export type GateReason = 'permission' | 'feature' | 'standard' | 'storage_mode' | 'enterprise';
export type GateResult = { ok: true } | { ok: false; reason: GateReason };

/**
 * Permission-only gate: only inspects `requiredPermission`. Used by the outer
 * <PermissionGate> in operatorRouter so a user denied for RBAC reasons sees
 * "權限不足" rather than "此功能需要升級方案".
 */
export function getPermissionGateResult(
  item: Partial<MenuItem> & Partial<RouteEntry>,
  { permissions = [] }: VisibilityContext = {},
): GateResult {
  if (item.requiredPermission) {
    const [resource, action] = item.requiredPermission.split(':');
    const has =
      permissions.includes('*:*') ||
      permissions.includes(`${resource}:*`) ||
      permissions.includes(`*:${action}`) ||
      permissions.includes(item.requiredPermission);
    if (!has) return { ok: false, reason: 'permission' };
  }
  return { ok: true };
}

/**
 * Plan/feature/storageMode gate: ignores `requiredPermission`. Used by the
 * inner <PlanGate>; only routes whose permission gate already passed reach it.
 */
export function getPlanGateResult(
  item: Partial<MenuItem> & Partial<RouteEntry>,
  { enabledFeatures = [], isStandard = false, isEnterprise = false, storageMode }: VisibilityContext = {},
): GateResult {
  if (item.requiredFeature && !enabledFeatures.includes(item.requiredFeature)) {
    return { ok: false, reason: 'feature' };
  }
  if (item.hideInStandard && isStandard) return { ok: false, reason: 'standard' };
  if (item.onlyInStandard && !isStandard) return { ok: false, reason: 'feature' };
  // Enterprise 為合約制獨立機器，不需自助方案選擇 / 升級頁面（spec: BILLING_SPEC
  // §"Enterprise 前端 UI 限制"）。同層的 menu item 透過此旗標隱藏。
  if (item.hideInEnterprise && isEnterprise) return { ok: false, reason: 'enterprise' };
  if (
    Array.isArray(item.hiddenWhenStorageMode) &&
    storageMode &&
    item.hiddenWhenStorageMode.includes(storageMode)
  ) {
    return { ok: false, reason: 'storage_mode' };
  }
  return { ok: true };
}

/**
 * Decide whether a menu/route entry is visible given current plan + auth state.
 * Used by OperatorMenuContext / menu rendering. Both gates must pass.
 *
 * Route-level gating (operatorRouter) does NOT use this — it consumes
 * `getPermissionGateResult` and `getPlanGateResult` separately so it can show
 * the correct reason to the user.
 */
export function isMenuItemVisible(
  item: Partial<MenuItem> & Partial<RouteEntry>,
  ctx: VisibilityContext = {},
): boolean {
  return getPermissionGateResult(item, ctx).ok && getPlanGateResult(item, ctx).ok;
}

export const operatorMenuConfig: MenuItem[] = [
  // ==================== 工作台 ====================
  {
    key: 'dashboard',
    labelKey: 'operator.menu.dashboard',
    icon: DashboardOutlined,
    path: '/dashboard',
    section: MENU_SECTIONS.OPERATIONS,
  },

  // ==================== 入庫管理 ====================
  {
    key: 'inbounds',
    labelKey: 'operator.menu.inbounds.title',
    icon: FileDoneOutlined,
    path: '/inbounds',
    isParent: true,
    section: MENU_SECTIONS.OPERATIONS,
    requiredPermission: 'inbounds:read',
    children: [
      {
        key: 'inbounds.list',
        labelKey: 'operator.menu.inbounds.list',
        path: '/inbounds',
        requiredPermission: 'inbounds:read',
      },
      // 入庫驗收
      {
        key: 'inbounds.acceptance',
        labelKey: 'operator.menu.operations.inbound_acceptance',
        path: '/operations/inbound_acceptance',
        component: InboundAcceptanceLanding,
        requiredPermission: 'inbounds:write',
      },
    ],
  },

  // ==================== 採購管理 ====================
  {
    key: 'purchase_orders',
    labelKey: 'operator.menu.purchase_orders.title',
    icon: BookOutlined,
    path: '/purchase_orders',
    isParent: true,
    section: MENU_SECTIONS.OPERATIONS,
    requiredPermission: 'purchase_orders:read',
    children: [
      {
        key: 'purchase_orders.list',
        labelKey: 'operator.menu.purchase_orders.list',
        path: '/purchase_orders',
        component: PurchaseOrdersList,
        requiredPermission: 'purchase_orders:read',
      },
      {
        key: 'purchase_orders.suppliers',
        labelKey: 'operator.menu.suppliers.list',
        path: '/suppliers',
        component: SuppliersList,
        requiredPermission: 'suppliers:read',
      },
    ],
  },

  // ==================== 揀貨管理 ====================
  {
    key: 'picking',
    labelKey: 'operator.menu.picking.title',
    icon: FileTextOutlined,
    path: '/picking',
    isParent: true,
    section: MENU_SECTIONS.OPERATIONS,
    requiredPermission: 'orders:read',
    children: [
      {
        key: 'picking.generate',
        labelKey: 'operator.menu.picking_lists.generate',
        path: '/picking_lists/generate',
        component: CreatePickingList,
        requiredPermission: 'orders:write',
      },
      {
        key: 'picking.list',
        labelKey: 'operator.menu.picking_lists.list',
        path: '/picking_lists',
        component: PickingListsList,
        requiredPermission: 'orders:read',
      },
      {
        key: 'picking.history',
        labelKey: 'operator.menu.picking_lists.history',
        path: '/picking_lists/history',
        component: OperatorPickingMovementsList,
        requiredPermission: 'orders:read',
      },
      {
        key: 'picking.residual_totes',
        labelKey: 'operator.menu.picking_lists.residual_totes',
        path: '/picking_lists/residual_totes',
        component: ResidualTotes,
        requiredPermission: 'orders:read',
      },
      {
        key: 'picking.presets',
        labelKey: 'operator.menu.picking_lists.presets',
        path: '/picking_lists/presets',
        component: OperatorPickingListPresetList,
        requiredPermission: 'orders:read',
        requiredFeature: 'picking_list_presets',
      },
    ],
  },

  // ==================== 出貨作業 ====================
  {
    key: 'fulfillment_ops',
    labelKey: 'operator.menu.fulfillment_ops.title',
    icon: ThunderboltOutlined,
    path: '/operations',
    isParent: true,
    section: MENU_SECTIONS.OPERATIONS,
    requiredPermission: 'orders:read',
    children: [
      {
        key: 'fulfillment_ops.distribute',
        labelKey: 'operator.menu.operations.distribute',
        path: '/operations/distribute',
        component: Distribute,
        requiredPermission: 'orders:read',
      },
      {
        key: 'fulfillment_ops.fulfillment_qc',
        labelKey: 'operator.menu.operations.fulfillment_qc',
        path: '/operations/fulfillment_qc',
        component: QcIndex,
        requiredPermission: 'orders:write',
      },
    ],
  },

  // ==================== 託運管理 ====================
  {
    key: 'shipments',
    labelKey: 'operator.menu.shipments.title',
    icon: CarOutlined,
    path: '/shipments',
    isParent: true,
    section: MENU_SECTIONS.OPERATIONS,
    requiredPermission: 'shipments:read',
    children: [
      {
        key: 'shipments.list',
        labelKey: 'operator.menu.shipments.list',
        path: '/shipments',
        component: ShipmentsList,
        requiredPermission: 'shipments:read',
      },
      {
        key: 'shipments.upload_labels',
        labelKey: 'operator.menu.shipments.upload_labels',
        path: '/shipments/upload_labels',
        component: OperatorUploadLabels,
        requiredPermission: 'shipments:write',
      },
    ],
  },

  // ==================== 訂單管理 ====================
  {
    key: 'orders',
    labelKey: 'operator.menu.orders.title',
    icon: ShoppingOutlined,
    path: '/orders',
    isParent: true,
    section: MENU_SECTIONS.OPERATIONS,
    requiredPermission: 'orders:read',
    children: [
      {
        key: 'orders.list',
        labelKey: 'operator.menu.orders.list',
        path: '/orders',
        component: OrdersList,
        requiredPermission: 'orders:read',
      },
      {
        key: 'orders.holds',
        labelKey: 'operator.menu.orders.holds',
        path: '/order_holds',
        component: OperatorOrderHoldsList,
        requiredPermission: 'orders:read',
      },
      {
        key: 'orders.fulfillments',
        labelKey: 'operator.menu.orders.fulfillments',
        path: '/fulfillments',
        component: FulfillmentsList,
        requiredPermission: 'orders:read',
      },
      {
        key: 'orders.out_of_stock',
        labelKey: 'operator.menu.orders.out_of_stock',
        path: '/orders/out_of_stock',
        component: OperatorOutOfStockProductsList,
        requiredPermission: 'orders:read',
      },
      {
        key: 'orders.templates',
        labelKey: 'operator.menu.orders.templates',
        path: '/order_templates',
        component: OperatorOrderTemplatesList,
        requiredPermission: 'orders:read',
      },
      {
        key: 'fulfillments.merge',
        labelKey: 'operator.menu.fulfillments.merge',
        path: '/fulfillments/merge',
        component: OperatorFulfillmentMerge,
        requiredPermission: 'orders:write',
      },
      {
        key: 'orders.serial_numbers',
        labelKey: 'operator.menu.orders.serial_numbers',
        path: '/orders/serial_numbers',
        component: SerialNumbersList,
        requiredPermission: 'orders:read',
        requiredFeature: 'orders.serial_numbers',
      },
      {
        key: 'orders.contact_addresses',
        labelKey: 'operator.menu.contact_addresses.title',
        path: '/contact_addresses',
        component: ContactAddressList,
        requiredPermission: 'contact_addresses:read',
      },
    ],
  },

  // ==================== 退貨管理 ====================
  {
    key: 'returns',
    labelKey: 'operator.menu.return_orders.title',
    icon: RollbackOutlined,
    path: '/return_orders',
    isParent: true,
    section: MENU_SECTIONS.OPERATIONS,
    requiredPermission: 'return_orders:read',
    children: [
      {
        key: 'returns.list',
        labelKey: 'operator.menu.return_orders.list',
        path: '/return_orders',
        component: ReturnOrdersList,
        requiredPermission: 'return_orders:read',
      },
      {
        key: 'returns.verification',
        labelKey: 'operator.menu.operations.return_check',
        path: '/return_orders/verification',
        component: ReturnOrderVerificationIndex,
        requiredPermission: 'return_orders:write',
      },
      {
        key: 'returns.pending_convert',
        labelKey: 'operator.menu.return_orders.pending_convert',
        path: '/return_receipts/pending_convert',
        component: ReturnReceiptPendingConvert,
        requiredPermission: 'return_orders:write',
      },
    ],
  },

  // ==================== 庫存管理 ====================
  {
    key: 'stocks',
    labelKey: 'operator.menu.stocks.title',
    icon: InboxOutlined,
    path: '/stocks',
    isParent: true,
    section: MENU_SECTIONS.INVENTORY,
    requiredPermission: 'products:read',
    children: [
      {
        key: 'stocks.list',
        labelKey: 'operator.menu.stocks.list',
        path: '/stocks',
        component: OperatorInventoriesList,
        requiredPermission: 'inventories:read',
      },
      {
        key: 'stocks.adjustments',
        labelKey: 'operator.menu.stocks.adjustments',
        path: '/stock_adjustments',
        component: StockAdjustmentsList,
        requiredPermission: 'stock_adjustments:read',
      },
      {
        key: 'stocks.transformations',
        labelKey: 'operator.menu.stocks.transformations',
        path: '/inventory_transformations',
        component: InventoryTransformationsList,
        requiredPermission: 'inventories:read',
      },
      {
        key: 'stocks.inventory_type_reclassify_rules',
        labelKey: 'operator.menu.stocks.inventory_type_reclassify_rules',
        path: '/inventory_type_reclassify_rules',
        component: OperatorInventoryTypeReclassifyRulesList,
        requiredPermission: 'inventories:read',
      },
      {
        key: 'stocks.inventory_holds',
        labelKey: 'operator.menu.stocks.inventory_holds',
        path: '/inventory_holds',
        component: OperatorInventoryHoldsList,
        requiredPermission: 'inventory_holds:read',
      },
      {
        key: 'stocks.shelves',
        labelKey: 'operator.menu.stocks.shelves',
        path: '/shelves',
        component: ShelvesList,
        requiredPermission: 'warehouses:read',
        hiddenWhenStorageMode: ['virtual'],
      },
      {
        key: 'stocks.stock_takings',
        labelKey: 'operator.menu.stock_takings.title',
        path: '/stock_takings',
        component: StockTakingsList,
        requiredPermission: 'stock_takings:read',
      },
    ],
  },

  // ==================== 庫存報表 ====================
  {
    key: 'stock_reports',
    labelKey: 'operator.menu.stock_reports.title',
    icon: BarChartOutlined,
    path: '/inventory_movements',
    isParent: true,
    section: MENU_SECTIONS.INVENTORY,
    requiredPermission: 'inventories:read',
    children: [
      {
        key: 'stock_reports.inventory_movements',
        labelKey: 'operator.menu.stock_reports.inventory_movements',
        path: '/inventory_movements',
        component: OperatorInventoryMovementsList,
        requiredPermission: 'inventories:read',
      },
      {
        key: 'stock_reports.trackers',
        labelKey: 'operator.menu.stock_reports.trackers',
        path: '/inventory_monitors',
        component: OperatorInventoryMonitorsList,
        requiredPermission: 'inventories:read',
        requiredFeature: 'inventory_monitors',
      },
      {
        key: 'stock_reports.history',
        labelKey: 'operator.menu.stock_reports.history',
        path: '/inventory_snapshots',
        component: OperatorInventorySnapshotsList,
        requiredPermission: 'inventories:read',
        requiredFeature: 'inventory_snapshots',
      },
      {
        key: 'stock_reports.shelf_movements',
        labelKey: 'operator.menu.stock_reports.shelf_movements',
        path: '/shelf_movements',
        component: OperatorShelfMovementsList,
        requiredPermission: 'shelves:read',
        hiddenWhenStorageMode: ['virtual'],
      },
      {
        key: 'stock_reports.location_snapshots',
        labelKey: 'operator.menu.stock_reports.location_snapshots',
        path: '/location_snapshots',
        component: OperatorLocationSnapshotsList,
        requiredPermission: 'inventories:read',
        hiddenWhenStorageMode: ['virtual'],
      },
    ],
  },

  // ==================== 生產管理 ====================
  {
    key: 'production',
    labelKey: 'operator.menu.production.title',
    icon: ToolOutlined,
    path: '/production',
    isParent: true,
    section: MENU_SECTIONS.INVENTORY,
    requiredPermission: 'work_orders:read',
    children: [
      {
        key: 'production.work_orders',
        labelKey: 'operator.menu.production.work_orders.title',
        path: '/work_orders',
        component: WorkOrdersList,
        requiredPermission: 'work_orders:read',
        requiredFeature: 'work_orders',
      },
      {
        key: 'production.material_picking',
        labelKey: 'operator.menu.production.material_picking.title',
        path: '/material_picking',
        component: MaterialPickingList,
        requiredPermission: 'work_orders:read',
        requiredFeature: 'work_orders',
      },
      {
        key: 'production.production_boms',
        labelKey: 'operator.menu.production.production_boms.title',
        path: '/production_boms',
        component: OperatorProductionBomsList,
        requiredPermission: 'work_orders:read',
        requiredFeature: 'production_boms',
      },
    ],
  },

  // ==================== 補貨管理 ====================
  {
    key: 'replenishment',
    labelKey: 'operator.menu.replenishment.title',
    icon: ThunderboltOutlined,
    path: '/replenishment_orders',
    isParent: true,
    section: MENU_SECTIONS.INVENTORY,
    requiredPermission: 'inventories:read',
    requiredFeature: 'replenishment_orders',
    // 補貨僅適用 dynamic 倉（後端 ensure_replenishment_dynamic_warehouse! 對 virtual / dedicated
    // 倉回 422 replenishment_requires_dynamic_warehouse）。在選單層擋掉，非 dynamic 倉的 operator
    // 不會進到只會報錯的頁面（比照 feature gate 不打 API 的模式）。
    hiddenWhenStorageMode: ['virtual', 'dedicated'],
    children: [
      {
        key: 'replenishment.orders',
        labelKey: 'operator.menu.replenishment.orders',
        path: '/replenishment_orders',
        component: ReplenishmentOrdersList,
        requiredPermission: 'inventories:read',
        requiredFeature: 'replenishment_orders',
        hiddenWhenStorageMode: ['virtual', 'dedicated'],
      },
      {
        key: 'replenishment.needs',
        labelKey: 'operator.menu.replenishment.needs',
        path: '/replenishment_needs',
        component: ReplenishmentNeeds,
        requiredPermission: 'inventories:read',
        requiredFeature: 'replenishment_orders',
        hiddenWhenStorageMode: ['virtual', 'dedicated'],
      },
      {
        key: 'replenishment.shelves',
        labelKey: 'operator.menu.replenishment.shelves',
        path: '/replenishment_shelves',
        component: ReplenishmentShelvesList,
        requiredPermission: 'inventories:read',
        requiredFeature: 'replenishment_orders',
        hiddenWhenStorageMode: ['virtual', 'dedicated'],
      },
    ],
  },

  // ==================== 調撥管理 ====================
  {
    key: 'stock_transfer_orders',
    labelKey: 'operator.menu.stock_transfer_orders.title',
    icon: SwapOutlined,
    path: '/stock_transfer_orders',
    isParent: true,
    section: MENU_SECTIONS.OPERATIONS,
    requiredPermission: 'stock_transfer_orders:read',
    requiredFeature: 'stock_transfer_orders',
    children: [
      {
        key: 'stock_transfer_orders.list',
        labelKey: 'operator.menu.stock_transfer_orders.list',
        path: '/stock_transfer_orders',
        component: StockTransferOrdersList,
        requiredPermission: 'stock_transfer_orders:read',
        requiredFeature: 'stock_transfer_orders',
      },
    ],
  },

  // ==================== 商品管理 ====================
  {
    key: 'products',
    labelKey: 'operator.menu.products.title',
    icon: AppstoreOutlined,
    path: '/products',
    isParent: true,
    section: MENU_SECTIONS.DATA,
    requiredPermission: 'products:read',
    children: [
      {
        key: 'products.list',
        labelKey: 'operator.menu.products.list',
        path: '/products',
        requiredPermission: 'products:read',
      },
      {
        key: 'products.bundles',
        labelKey: 'operator.menu.products.bundles.title',
        path: '/bundles',
        requiredPermission: 'products:read',
      },
      {
        key: 'products.flexible_products',
        labelKey: 'operator.menu.products.flexible_products.title',
        path: '/flexible_products',
        requiredPermission: 'products:read',
        requiredFeature: 'flexible_products',
      },
      {
        key: 'products.brands',
        labelKey: 'operator.menu.products.brands.title',
        path: '/brands',
        component: BrandsList,
        requiredPermission: 'brands:read',
        requiredFeature: 'brands',
      },
      {
        key: 'products.unknown',
        labelKey: 'operator.menu.products.unknown',
        path: '/unknown_products',
        component: OperatorUnknownProductsList,
        requiredPermission: 'products:read',
      },
      {
        key: 'products.product_categories',
        labelKey: 'operator.menu.products.product_categories.title',
        path: '/product_categories',
        component: ProductCategoriesList,
        requiredPermission: 'products:read',
      },
      {
        key: 'products.sluggish',
        labelKey: 'operator.menu.products.sluggish',
        path: '/sluggish_products',
        component: OperatorSluggishProductsIndex,
        requiredPermission: 'products:read',
      },
      {
        key: 'products.label_templates',
        labelKey: 'operator.menu.products.label_templates.title',
        path: '/product_label_templates',
        component: OperatorProductLabelTemplatesList,
        requiredPermission: 'products:read',
      },
      {
        key: 'products.serial_numbers',
        labelKey: 'operator.menu.products.serial_numbers',
        path: '/product_serial_numbers',
        component: OperatorProductSerialNumbersList,
        requiredPermission: 'products:read',
      },
      {
        key: 'products.replace_sku',
        labelKey: 'operator.menu.products.replace_sku',
        path: '/products/replace_sku',
        component: ReplaceSku,
        requiredPermission: 'products:write',
      },
    ],
  },

  // ==================== 報表中心 ====================
  {
    key: 'reports',
    labelKey: 'operator.menu.reports.title',
    icon: BarChartOutlined,
    path: '/reports',
    isParent: true,
    section: MENU_SECTIONS.REPORTS,
    requiredPermission: 'reports:read',
    children: [
      {
        key: 'reports.orders',
        labelKey: 'operator.menu.reports.orders',
        path: '/reports/orders',
        component: OrderReports,
        requiredPermission: 'reports:read',
      },
      {
        key: 'reports.slotting_analysis',
        labelKey: 'operator.menu.reports.slotting_analysis',
        path: '/reports/slotting_analysis',
        component: SlottingAnalysis,
        requiredPermission: 'reports:read',
      },
      {
        key: 'reports.workforce_stats',
        labelKey: 'operator.menu.reports.workforce_stats',
        path: '/workforce_stats',
        component: WorkforceStatsDailySummary,
        requiredPermission: 'reports:read',
      },
    ],
  },

  // ==================== 看板 ====================
  {
    key: 'monitor',
    labelKey: 'operator.menu.monitor.title',
    icon: FundProjectionScreenOutlined,
    path: '/monitor',
    isParent: true,
    section: MENU_SECTIONS.MONITOR,
    children: [
      {
        key: 'monitor.fulfillment_dashboard',
        labelKey: 'operator.menu.monitor.fulfillment_dashboard',
        path: '/fulfillment-dashboard',
        component: FulfillmentWall,
      },
      {
        key: 'monitor.picking_dashboard',
        labelKey: 'operator.menu.monitor.picking_dashboard',
        path: '/picking-dashboard',
        component: PickingWall,
      },
      {
        key: 'monitor.inbound_dashboard',
        labelKey: 'operator.menu.monitor.inbound_dashboard',
        path: '/inbound-dashboard',
        component: InboundWall,
      },
      {
        key: 'monitor.carrier_dashboard',
        labelKey: 'operator.menu.monitor.carrier_dashboard',
        path: '/carrier-dashboard',
        component: CarrierWall,
      },
      {
        key: 'monitor.exception_dashboard',
        labelKey: 'operator.menu.monitor.exception_dashboard',
        path: '/exception-dashboard',
        component: ExceptionWall,
      },
    ],
  },

  // ===================================================================
  // 進階區塊 (ADVANCED SECTION) - 預設收合
  // ===================================================================

  // ==================== 組織管理 ====================
  {
    key: 'org_management',
    labelKey: 'operator.menu.org_management.title',
    icon: SettingOutlined,
    path: '/org_management',
    isParent: true,
    section: MENU_SECTIONS.ADVANCED,
    requiredPermission: 'organizations:read',
    children: [
      {
        key: 'org_management.organization',
        labelKey: 'operator.menu.system_settings.organization',
        path: '/system_settings/organization',
        component: OrganizationSettings,
        requiredPermission: 'organizations:read',
      },
      {
        key: 'org_management.operators',
        labelKey: 'operator.menu.system_settings.operators',
        path: '/operators',
        component: OperatorsList,
        requiredPermission: 'operators:read',
      },
      {
        key: 'org_management.holidays',
        labelKey: 'operator.menu.system_settings.holidays',
        path: '/system_settings/holidays',
        component: HolidaysList,
        requiredPermission: 'organizations:write',
      },
      {
        key: 'org_management.accessible_ips',
        labelKey: 'operator.menu.system_settings.accessible_ips',
        path: '/accessible_ip_addresses',
        component: OperatorAccessibleIpAddressesList,
        requiredPermission: 'accessible_ip_addresses:read',
        requiredFeature: 'accessible_ip_addresses',
      },
      {
        key: 'org_management.warehouse_broadcasts',
        labelKey: 'operator.menu.warehouse_broadcasts',
        path: '/warehouse_broadcasts',
        component: WarehouseBroadcastsList,
        requiredFeature: 'warehouse_broadcasts',
      },
    ],
  },

  // ==================== 倉庫設定 ====================
  {
    key: 'warehouse_settings',
    labelKey: 'operator.menu.warehouse_settings.title',
    icon: InboxOutlined,
    path: '/warehouse_settings',
    isParent: true,
    section: MENU_SECTIONS.ADVANCED,
    requiredPermission: 'warehouses:read',
    children: [
      {
        key: 'warehouse_settings.warehouses',
        labelKey: 'operator.menu.system_settings.warehouses',
        path: '/warehouses',
        component: WarehousesList,
        requiredPermission: 'warehouses:read',
      },
      {
        key: 'warehouse_settings.shelf_types',
        labelKey: 'operator.menu.warehouse_settings.shelf_types',
        path: '/shelf_types',
        component: ShelfTypesList,
        requiredPermission: 'warehouses:read',
        hiddenWhenStorageMode: ['virtual'],
      },
      {
        key: 'warehouse_settings.shelves_batch_new',
        labelKey: 'shared.shelves.list.actions.new',
        path: '/shelves/batch_new',
        component: ShelvesBatchNew,
        requiredPermission: 'warehouses:read',
        hiddenWhenStorageMode: ['virtual'],
      },
      {
        key: 'warehouse_settings.inventory_types',
        labelKey: 'operator.menu.data.inventory_types',
        path: '/data/inventory_types',
        component: OperatorInventoryTypesList,
        requiredPermission: 'merchants:read',
      },
      {
        key: 'warehouse_settings.consumables',
        labelKey: 'operator.menu.consumables.title',
        path: '/consumables',
        component: ConsumablesList,
        requiredPermission: 'consumables:read',
      },
    ],
  },

  // ==================== 物流設定 ====================
  {
    key: 'shipping_settings',
    labelKey: 'operator.menu.shipping_settings.title',
    icon: CarOutlined,
    path: '/shipping_settings',
    isParent: true,
    section: MENU_SECTIONS.ADVANCED,
    requiredPermission: 'shipments:read',
    children: [
      {
        key: 'shipping_settings.rate_cards',
        labelKey: 'operator.menu.shipping_settings.shipping_rate_cards',
        path: '/shipping_rate_cards',
        component: ShippingRateCardsList,
        requiredPermission: 'merchants:read',
      },
      {
        key: 'shipping_settings.shipping_accounts',
        labelKey: 'operator.menu.shipping_settings.shipping_accounts',
        path: '/shipping_accounts',
        component: OperatorShippingAccountsList,
        requiredPermission: 'shipments:read',
      },
      {
        key: 'shipping_settings.shipping_types',
        labelKey: 'operator.menu.data.shipping_types',
        path: '/data/shipping_types',
        component: OperatorShippingTypesList,
        requiredPermission: 'shipments:read',
      },
    ],
  },

  // ==================== 銷售通路 (top-level) ====================
  // 原本掛在 merchant_settings 下，但語意上屬於「通路整合」而非貨主設定。
  // 提升為 top-level 使兩種 plan 的選單語意都更清楚；在 standard 下
  // merchant_settings 會因剩餘子項全數被 hide 而自動 parent-hide。
  {
    key: 'sales_channels',
    labelKey: 'operator.menu.data.sales_channels',
    icon: ShopOutlined,
    path: '/data/sales_channels',
    component: OperatorSalesChannelsList,
    section: MENU_SECTIONS.ADVANCED,
    requiredPermission: 'merchants:read',
  },

  // ==================== 電商帳號 (top-level) ====================
  {
    key: 'ec_accounts',
    labelKey: 'operator.menu.ec_accounts',
    icon: LinkOutlined,
    path: '/ec_accounts',
    component: OperatorEcAccountsList,
    section: MENU_SECTIONS.ADVANCED,
    requiredPermission: 'ec_accounts:read',
  },

  // ==================== 我的貨主 (standard 方案 top-level) ====================
  {
    key: 'my_merchant',
    labelKey: 'operator.menu.merchant_settings.my_merchant',
    icon: SettingOutlined,
    path: '/my_merchant',
    component: MyMerchant,
    section: MENU_SECTIONS.ADVANCED,
    requiredPermission: 'merchants:read',
    onlyInStandard: true,
  },

  // ==================== 貨主設定 ====================
  {
    key: 'merchant_settings',
    labelKey: 'operator.menu.merchant_settings.title',
    icon: CalculatorOutlined,
    path: '/merchant_settings',
    isParent: true,
    section: MENU_SECTIONS.ADVANCED,
    requiredPermission: 'merchants:read',
    children: [
      {
        key: 'merchant_settings.merchants',
        labelKey: 'operator.menu.merchants_billings.merchants',
        path: '/merchants',
        component: MerchantsList,
        requiredPermission: 'merchants:read',
        hideInStandard: true,
      },
      {
        key: 'merchant_settings.billings',
        labelKey: 'operator.menu.merchants_billings.billings',
        path: '/billings',
        component: BillingsList,
        requiredPermission: 'merchants:read',
        requiredFeature: 'billings',
      },
      {
        key: 'merchant_settings.value_added_services',
        labelKey: 'operator.menu.merchants_billings.value_added_services',
        path: '/value_added_services',
        component: ValueAddedServicesList,
        requiredPermission: 'merchants:read',
        requiredFeature: 'value_added_services',
      },
      {
        key: 'merchant_settings.merchant_inventory_types',
        labelKey: 'operator.menu.data.merchant_inventory_types',
        path: '/data/merchant_inventory_types',
        component: OperatorMerchantInventoryTypesList,
        requiredPermission: 'merchants:read',
        hideInStandard: true,
      },
      {
        key: 'merchant_settings.merchant_shipping_types',
        labelKey: 'operator.menu.system_settings.merchant_shipping_types',
        path: '/system_settings/merchant_shipping_types',
        component: OperatorMerchantShippingTypesList,
        requiredPermission: 'merchants:write',
        hideInStandard: true,
      },
    ],
  },

  // ==================== 串接紀錄 ====================
  {
    key: 'integration_logs',
    labelKey: 'operator.menu.integration_logs.title',
    icon: ApiOutlined,
    path: '/integration_logs',
    isParent: true,
    section: MENU_SECTIONS.ADVANCED,
    requiredPermission: 'logs:read',
    children: [
      {
        key: 'integration_logs.api_logs',
        labelKey: 'operator.menu.integration_logs.third_party_api_logs',
        path: '/third_party_api_logs',
        component: OperatorThirdPartyApiLogsList,
        requiredPermission: 'logs:read',
      },
      {
        key: 'integration_logs.webhook_deliveries',
        labelKey: 'operator.menu.integration_logs.webhook_deliveries',
        path: '/webhook_deliveries',
        component: OperatorWebhookDeliveriesList,
        requiredPermission: 'logs:read',
      },
      {
        key: 'integration_logs.imports',
        labelKey: 'operator.menu.integration_logs.imports',
        path: '/imports',
        component: ImportsList,
        requiredPermission: 'logs:read',
      },
    ],
  },

  // ==================== 帳務管理 ====================
  {
    key: 'governance',
    labelKey: 'operator.menu.governance.title',
    icon: CrownOutlined,
    path: '/governance',
    isParent: true,
    section: MENU_SECTIONS.ADVANCED,
    requiredPermission: 'governance:read',
    children: [
      {
        key: 'governance.subscription',
        labelKey: 'operator.menu.governance.subscription',
        path: '/governance/subscription',
        component: GovernanceSubscription,
        requiredPermission: 'governance:read',
      },
      {
        key: 'governance.invoices',
        labelKey: 'operator.menu.governance.invoices',
        path: '/governance/invoices',
        component: GovernanceInvoices,
        requiredPermission: 'governance:read',
      },
      {
        key: 'governance.pricing_plans',
        labelKey: 'operator.menu.governance.pricing_plans',
        path: '/governance/pricing_plans',
        component: GovernancePricingPlans,
        requiredPermission: 'governance:read',
        // Enterprise 合約方案不允許自助變更，整個方案選擇頁對 Enterprise 隱藏
        hideInEnterprise: true,
      },
      {
        key: 'governance.payment_methods',
        labelKey: 'operator.menu.governance.payment_methods',
        path: '/governance/payment_methods',
        component: GovernancePaymentMethods,
        requiredPermission: 'governance:read',
      },
      {
        key: 'governance.billing_profile',
        labelKey: 'operator.menu.governance.billing_profile',
        path: '/governance/billing_profile',
        component: GovernanceBillingProfile,
        requiredPermission: 'governance:read',
      },
      {
        key: 'governance.pcs_ledger',
        labelKey: 'operator.menu.governance.pcs_ledger',
        path: '/governance/pcs_ledger',
        component: GovernancePcsLedger,
        requiredPermission: 'governance:read',
      },
      {
        key: 'governance.ai_audit_logs',
        labelKey: 'operator.menu.governance.ai_audit_logs',
        path: '/governance/ai_audit_logs',
        component: OperatorAiAuditLogsList,
        requiredPermission: 'governance:read',
      },
      {
        key: 'governance.ai_usage',
        labelKey: 'operator.menu.governance.ai_usage',
        path: '/governance/ai_usage',
        component: GovernanceAiUsage,
        requiredPermission: 'governance:read',
      },
    ],
  },
];

// ==================== 選單元數據 ====================

// 從 menuConfig 自動生成 menuMeta（支援任意層級巢狀）
const generateMenuMeta = (menuConfig: MenuItem[]): Record<string, MenuMetaEntry> => {
  const meta: Record<string, MenuMetaEntry> = {};

  const walk = (items: MenuItem[], parentKey?: string) => {
    items.forEach(item => {
      meta[item.key] = {
        path: item.path,
        external: false,
        labelKey: item.labelKey,
        ...(parentKey ? { parentKey } : {}),
      };
      if (item.children) walk(item.children, item.key);
    });
  };

  walk(menuConfig);
  return meta;
};

export const operatorMenuMeta: Record<string, MenuMetaEntry> = generateMenuMeta(operatorMenuConfig);

// ==================== Path to Key Mapping ====================

// 從 menuConfig 自動生成 pathToKeyMap（支援任意層級巢狀；只 map leaf）
const generatePathToKeyMap = (menuConfig: MenuItem[]): Record<string, string> => {
  const map: Record<string, string> = {};

  const walk = (items: MenuItem[]) => {
    items.forEach(item => {
      if (item.children && item.children.length > 0) {
        walk(item.children);
      } else {
        map[item.path] = item.key;
      }
    });
  };

  walk(menuConfig);
  return map;
};

export const operatorPathToKeyMap: Record<string, string> = generatePathToKeyMap(operatorMenuConfig);

// ==================== 路由配置 ====================

// 通用 loader 函數
// 失敗時拋出 Response，讓 React Router 的 isRouteErrorResponse 正確識別 status code，
// 由 RouteErrorBoundary 渲染對應的 404/403 等頁面。
const createLoader = (resource: string): LoaderFunction => async ({ params }) => {
  const { id } = params;
  try {
    const response = await operatorApiFetch(`${resource}/${id}`);
    if (!response.ok) {
      throw new Response(response.statusText || `Failed to fetch ${resource}/${id}`, { status: response.status });
    }
    const data = await response.json();
    // envelope 失敗也包成 Response，讓 isRouteErrorResponse 能正確抓到 status
    if (!data.success) {
      throw new Response(data.message || `Failed to load ${resource}`, { status: 500 });
    }
    return data.data;
  } catch (error) {
    console.error(`[Loader Error] ${resource}/${id}:`, error);
    if (error instanceof Response) throw error;
    const status = (error as { status?: number } | null)?.status;
    if (status) {
      throw new Response((error as { message?: string }).message || '', { status });
    }
    throw error;
  }
};

// Detail routes (with :id parameter) - Must be defined BEFORE list routes
const operatorDetailRoutes: RouteEntry[] = [
  // Profile (current operator)
  { path: '/profile', component: ProfileShow },

  // Workforce Stats - Operator Performance
  { path: '/workforce_stats/operator/:id', component: WorkforceStatsOperatorPerformance },

  // API Logs detail
  { path: '/third_party_api_logs/:id', component: OperatorThirdPartyApiLogsShow, loader: createLoader('third_party_api_logs') },

  // Import detail
  { path: '/imports/:id', component: ImportShow, loader: createLoader('imports') },

  // Merchant routes
  { path: '/merchants/new', component: MerchantNew, hideInStandard: true },
  { path: '/merchants/:id', component: MerchantShow, loader: createLoader('merchants') },

  // Billing routes
  { path: '/billings/:id', component: BillingsShow, loader: createLoader('billings'), requiredFeature: 'billings' },

  // Product routes
  { path: '/products/new', component: OperatorProductNew, requiredPermission: 'products:write' },
  { path: '/products/:id/edit', component: ProductEdit },
  { path: '/products/:id/inventory', component: ProductInventory, loader: createLoader('products') },
  { path: '/products/:id', component: ProductShow, loader: createLoader('products') },

  // Unknown product routes
  { path: '/unknown_products/:id', component: OperatorUnknownProductShow, loader: createLoader('unknown_products') },

  // Inventory routes
  {
    path: '/inventories/:id/orders', component: OperatorInventoryOrders, loader: async ({ params }) => {
      const response = await operatorApiFetch(`inventories/${params.id}/allocations`);
      if (!response.ok) throw new Error('Failed to fetch inventory allocations');
      const data = await response.json();
      if (!data.success) throw new Error(data.message || 'Failed to load inventory allocations');
      return data.data;
    }
  },

  // Bundle routes
  { path: '/bundles/new', component: OperatorBundleNew },
  { path: '/bundles/:id/edit', component: BundlesEdit },
  { path: '/bundles/:id', component: BundlesShow, loader: createLoader('bundles') },

  // Flexible product routes
  { path: '/flexible_products/new', component: OperatorFlexibleProductNew, requiredFeature: 'flexible_products' },
  { path: '/flexible_products/:id/edit', component: FlexibleProductsEdit, requiredFeature: 'flexible_products' },
  { path: '/flexible_products/:id', component: FlexibleProductsShow, loader: createLoader('flexible_products'), requiredFeature: 'flexible_products' },

  // Process BOM routes
  { path: '/production_boms/new', component: OperatorProductionBomNew, requiredFeature: 'production_boms' },
  { path: '/production_boms/:id/edit', component: OperatorProductionBomEdit, requiredFeature: 'production_boms' },
  { path: '/production_boms/:id', component: OperatorProductionBomShow, loader: createLoader('production_boms'), requiredFeature: 'production_boms' },

  // Inbound routes
  { path: '/inbounds/new', component: OperatorInboundNew },
  { path: '/inbounds/:id/edit', component: InboundsEdit },
  { path: '/inbounds/:id', component: InboundsShow, loader: createLoader('inbounds') },
  { path: '/inbounds/:id/acceptance', component: InboundAcceptance, loader: createLoader('inbounds') },

  // Receipt routes
  { path: '/receipts/:id/putaway', component: ReceiptPutaway, loader: createLoader('receipts') },

  // Supplier routes
  { path: '/suppliers/new', component: OperatorSupplierNew },
  { path: '/suppliers/:id/edit', component: SuppliersEdit },
  { path: '/suppliers/:id', component: SuppliersShow, loader: createLoader('suppliers') },

  // Purchase Order routes
  { path: '/purchase_orders/new', component: OperatorPurchaseOrderNew },
  { path: '/purchase_orders/:id/edit', component: PurchaseOrdersEdit },
  { path: '/purchase_orders/:id', component: PurchaseOrdersShow, loader: createLoader('purchase_orders') },

  // Inventory Monitor routes
  { path: '/inventory_monitors/new', component: OperatorInventoryMonitorNew, requiredFeature: 'inventory_monitors' },
  { path: '/inventory_monitors/:id/edit', component: OperatorInventoryMonitorsEdit, requiredFeature: 'inventory_monitors' },
  { path: '/inventory_monitors/:id', component: OperatorInventoryMonitorsShow, loader: createLoader('inventory_monitors'), requiredFeature: 'inventory_monitors' },

  // Stock Transfer Order routes
  { path: '/stock_transfer_orders/new', component: StockTransferOrderNew, requiredFeature: 'stock_transfer_orders' },
  { path: '/stock_transfer_orders/:id/edit', component: StockTransferOrderEdit, loader: createLoader('stock_transfer_orders'), requiredFeature: 'stock_transfer_orders' },
  { path: '/stock_transfer_orders/:id', component: StockTransferOrderShow, loader: createLoader('stock_transfer_orders'), requiredFeature: 'stock_transfer_orders' },

  // Replenishment Order routes
  // Show 自行透過 replenishmentService.get(id) 載入（與 PickingListShow 同模式），不用 loader。
  { path: '/replenishment_orders/:id', component: ReplenishmentOrderShow, requiredPermission: 'inventories:read', requiredFeature: 'replenishment_orders' },

  // Replenishment Shelf (揀補儲位 slot 設定) routes
  // New 用 <MerchantSelect> 建立 merchant context；Edit 自行 getShelf(id) 載入 + useRecordMerchantSync。
  // 兩者皆受 inventories:write + replenishment_orders feature gate（List 是 inventories:read，
  // 但新增/編輯是寫入動作）。createBrowserRouter 會把靜態 /new 排在 /:id/edit 之前，無 shadowing。
  { path: '/replenishment_shelves/new', component: ReplenishmentShelvesNew, requiredPermission: 'inventories:write', requiredFeature: 'replenishment_orders' },
  { path: '/replenishment_shelves/:id/edit', component: ReplenishmentShelvesEdit, requiredPermission: 'inventories:write', requiredFeature: 'replenishment_orders' },

  // Work Order routes
  { path: '/work_orders/new', component: WorkOrderNew, requiredFeature: 'work_orders' },
  { path: '/work_orders/:id/edit', component: WorkOrderEdit, loader: createLoader('work_orders'), requiredFeature: 'work_orders' },
  { path: '/work_orders/:id', component: WorkOrderShow, loader: createLoader('work_orders'), requiredFeature: 'work_orders' },

  // Order routes
  { path: '/orders/new', component: OrderNew },
  { path: '/orders/:id/edit', component: OrderEdit },
  { path: '/orders/:id', component: OrderShow, loader: createLoader('orders') },

  // Fulfillment routes
  { path: '/fulfillments/:id', component: FulfillmentShow, loader: createLoader('fulfillments') },

  // Contact address routes
  { path: '/contact_addresses/new', component: OperatorContactAddressNew },
  { path: '/contact_addresses/:id/edit', component: ContactAddressEdit },
  { path: '/contact_addresses/:id', component: ContactAddressShow, loader: createLoader('contact_addresses') },

  // Consumable routes
  { path: '/consumables/new', component: OperatorConsumableNew },
  { path: '/consumables/:id/edit', component: ConsumablesEdit },
  { path: '/consumables/:id', component: ConsumablesShow, loader: createLoader('consumables') },

  // Brand routes
  { path: '/brands/new', component: BrandsNew, requiredFeature: 'brands' },
  { path: '/brands/:id', component: BrandsShow, loader: createLoader('brands'), requiredFeature: 'brands' },

  // ShelfType routes
  { path: '/shelf_types/:id', component: ShelfTypesShow, loader: createLoader('shelf_types') },

  // ProductCategory routes
  { path: '/product_categories/new', component: ProductCategoryNew },
  { path: '/product_categories/:id/edit', component: ProductCategoryNew },
  { path: '/product_categories/:id', component: ProductCategoryShow, loader: createLoader('product_categories') },

  // Shelf routes
  { path: '/shelves/batch_new', component: ShelvesBatchNew },
  { path: '/shelves/:id', component: ShelvesShow, loader: createLoader('shelves') },

  // Return order routes
  // /return_orders/verification 由 menuConfig children (returns.verification) 自動產生 placeholder route
  { path: '/return_orders/new', component: OperatorReturnOrderNew },
  { path: '/return_orders/collect', component: ReturnOrderCollect },
  { path: '/return_orders/:id/edit', component: ReturnOrderEdit },
  { path: '/return_orders/:id', component: ReturnOrderShow, loader: createLoader('return_orders') },
  { path: '/return_receipts/:id', component: ReturnReceiptShow, loader: createLoader('return_receipts') },

  // Picking wave routes
  { path: '/picking_waves/:id', component: PickingWaveShow },

  // Picking list routes
  // /picking_lists/generate 由 menuConfig children (picking.generate) 自動產生 placeholder route
  { path: '/picking_lists/presets/new', component: OperatorPickingListPresetNew, requiredFeature: 'picking_list_presets' },
  { path: '/picking_lists/presets/:id', component: OperatorPickingListPresetEdit, requiredFeature: 'picking_list_presets' },
  { path: '/picking_lists/:id/confirm', component: PickingListConfirm },
  { path: '/picking_lists/:id', component: PickingListShow },

  // Stock Taking routes
  { path: '/stock_takings/new', component: StockTakingNew },
  { path: '/stock_takings/:id/shelves/:shelfId', component: StockTakingShelfEdit },
  { path: '/stock_takings/:id', component: StockTakingShow, loader: createLoader('stock_takings') },

  // Stock Adjustment routes
  { path: '/stock_adjustments/new', component: StockAdjustmentNew },
  { path: '/stock_adjustments/:id/edit', component: StockAdjustmentEdit, loader: createLoader('stock_adjustments') },
  { path: '/stock_adjustments/:id', component: StockAdjustmentShow, loader: createLoader('stock_adjustments') },

  // Inventory Transformation routes
  { path: '/inventory_transformations/new', component: InventoryTransformationNew },
  { path: '/inventory_transformations/:id/edit', component: InventoryTransformationEdit, loader: createLoader('inventory_transformations') },
  { path: '/inventory_transformations/:id', component: InventoryTransformationShow, loader: createLoader('inventory_transformations') },

  // Inventory Hold routes
  { path: '/inventory_holds/new', component: OperatorInventoryHoldsNew },
  { path: '/inventory_holds/:id', component: OperatorInventoryHoldsShow, loader: createLoader('inventory_holds') },

  // Order Template routes
  { path: '/order_templates/new', component: OperatorOrderTemplateNew },
  { path: '/order_templates/:id/edit', component: OperatorOrderTemplateEdit, loader: createLoader('order_templates') },
  { path: '/order_templates/:id', component: OperatorOrderTemplateShow, loader: createLoader('order_templates') },

  // Product Label Template routes
  { path: '/product_label_templates/new', component: OperatorProductLabelTemplateNew },
  { path: '/product_label_templates/:id/edit', component: OperatorProductLabelTemplateEdit, loader: createLoader('product_label_templates') },
  { path: '/product_label_templates/:id', component: OperatorProductLabelTemplateShow, loader: createLoader('product_label_templates') },

  // Operators routes
  { path: '/operators/new', component: OperatorsNew },
  { path: '/operators/:id/edit', component: OperatorsEdit },
  { path: '/operators/:id/merchants', component: OperatorsMerchants },

  // Warehouse routes
  { path: '/warehouses/new', component: WarehouseNew },
  { path: '/warehouses/:id', component: WarehouseShow, loader: createLoader('warehouses') },

  // Merchant Channel routes
  { path: '/data/sales_channels/new', component: OperatorSalesChannelsNew },
  { path: '/data/sales_channels/:id/edit', component: OperatorSalesChannelsEdit, loader: createLoader('sales_channels') },
  { path: '/data/sales_channels/:id', component: OperatorSalesChannelsShow, loader: createLoader('sales_channels') },
  { path: '/sales_channels/:id/edit', component: OperatorSalesChannelsEdit, loader: createLoader('sales_channels') },
  { path: '/sales_channels/:id', component: OperatorSalesChannelsShow, loader: createLoader('sales_channels') },

  // Shipping Rate Card routes
  { path: '/shipping_rate_cards/new', component: OperatorShippingRateCardNew },
  { path: '/shipping_rate_cards/:id/edit', component: ShippingRateCardsEdit, loader: createLoader('shipping_rate_cards') },

  // Notification routes
  { path: '/notifications/:id', component: OperatorNotificationShow, loader: createLoader('notifications') },

  // EcAccount routes
  { path: '/ec_accounts/new', component: OperatorEcAccountNew },
  { path: '/ec_accounts/:id/edit', component: OperatorEcAccountEdit, loader: createLoader('ec_accounts') },
  { path: '/ec_accounts/:id', component: OperatorEcAccountShow },
];

// List routes and other non-parameterized routes
const operatorListRoutes: RouteEntry[] = [
  { path: '/dashboard', component: Dashboard },
  { path: '/products', component: ProductsList },
  { path: '/bundles', component: BundlesList },
  { path: '/flexible_products', component: FlexibleProductsList, requiredFeature: 'flexible_products' },
  { path: '/inbounds', component: InboundsList },
  { path: '/suppliers', component: SuppliersList },
  { path: '/purchase_orders', component: PurchaseOrdersList },
  { path: '/order_holds', component: OperatorOrderHoldsList },
  { path: '/orders', component: OrdersList },
  { path: '/fulfillments', component: FulfillmentsList },
  { path: '/orders/out_of_stock', component: OperatorOutOfStockProductsList },
  { path: '/contact_addresses', component: ContactAddressList },
  { path: '/consumables', component: ConsumablesList },
  { path: '/brands', component: BrandsList, requiredFeature: 'brands' },
  { path: '/shelf_types', component: ShelfTypesList },
  { path: '/product_categories', component: ProductCategoriesList },
  { path: '/return_orders', component: ReturnOrdersList },
  { path: '/picking_lists', component: PickingListsList },
  { path: '/picking_lists/presets', component: OperatorPickingListPresetList, requiredFeature: 'picking_list_presets' },
  { path: '/stock_takings', component: StockTakingsList },
  { path: '/stock_adjustments', component: StockAdjustmentsList },
  { path: '/inventory_transformations', component: InventoryTransformationsList },
  { path: '/inventory_type_reclassify_rules', component: OperatorInventoryTypeReclassifyRulesList },
  { path: '/stock_transfer_orders', component: StockTransferOrdersList },
  { path: '/work_orders', component: WorkOrdersList },
  { path: '/material_picking', component: MaterialPickingList },
  { path: '/shelf_movements', component: OperatorShelfMovementsList },
  { path: '/operators', component: OperatorsList },
  { path: '/warehouses', component: WarehousesList },
  { path: '/data/inventory_types', component: OperatorInventoryTypesList },
  { path: '/data/merchant_inventory_types', component: OperatorMerchantInventoryTypesList, hideInStandard: true },
  { path: '/workforce_stats', component: WorkforceStatsDailySummary },
  { path: '/billings', component: BillingsList, requiredFeature: 'billings' },
  { path: '/shipping_accounts', component: OperatorShippingAccountsList },
  { path: '/ec_accounts', component: OperatorEcAccountsList },
  { path: '/notifications', component: OperatorNotificationList },
  // AI routes
  // /ai_audit_logs kept as backward-compat alias — AI drawer header/sidebar
  // still navigate there. /governance/ai_audit_logs is the canonical path
  // used by the 訂閱計費 menu (consistent with /governance/ai_usage).
  { path: '/ai_audit_logs', component: OperatorAiAuditLogsList },
  { path: '/governance/ai_audit_logs', component: OperatorAiAuditLogsList },
  // Governance routes
  { path: '/governance/subscription', component: GovernanceSubscription },
  { path: '/governance/pricing_plans', component: GovernancePricingPlans },
  { path: '/governance/payment_methods', component: GovernancePaymentMethods },
  { path: '/governance/invoices', component: GovernanceInvoices },
  { path: '/governance/billing_profile', component: GovernanceBillingProfile },
  { path: '/governance/pcs_ledger', component: GovernancePcsLedger },
  { path: '/governance/ai_usage', component: GovernanceAiUsage },
];

// Merge detail routes FIRST, then list routes
// This ensures detail routes are matched before list routes
const manualRoutes: RouteEntry[] = [
  ...operatorDetailRoutes,
  ...operatorListRoutes,
];

// 從 menuConfig 自動生成 placeholder 路由
const generatePlaceholderRoutes = (menuConfig: MenuItem[]): RouteEntry[] => {
  const routes: RouteEntry[] = [];

  menuConfig.forEach(item => {
    if (item.component && item.path) {
      routes.push({
        path: item.path,
        component: item.component,
        requiredPermission: item.requiredPermission,
        requiredFeature: item.requiredFeature,
        hideInStandard: item.hideInStandard,
        onlyInStandard: item.onlyInStandard,
      });
    }

    if (item.children) {
      item.children.forEach(child => {
        if (child.component && child.path) {
          routes.push({
            path: child.path,
            component: child.component,
            requiredPermission: child.requiredPermission,
            requiredFeature: child.requiredFeature,
            hideInStandard: child.hideInStandard,
            onlyInStandard: child.onlyInStandard,
          });
        }
      });
    }
  });

  return routes;
};

const placeholderRoutes = generatePlaceholderRoutes(operatorMenuConfig);

// 合併手動路由和自動生成的 placeholder 路由（手動路由優先）
export const operatorRoutes: RouteEntry[] = [
  ...manualRoutes,
  ...placeholderRoutes.filter(
    pr => !manualRoutes.some(mr => mr.path === pr.path)
  ),
];

// ==================== 建立選單項目 ====================

type AntdMenuItem = AntdMenuItems[number] & { children?: AntdMenuItems };

// 權限過濾已由 OperatorMenuContext (透過 isMenuItemVisible) 完成；
// 此函式只負責把 MenuItem 轉成 antd 需要的 ItemType 形狀。
const toAntdMenuItems = (items: MenuItem[], t: TFunction): AntdMenuItems =>
  items
    .map((item) => {
      const labelText = t(item.labelKey);
      const hasChildren = Boolean(item.children && item.children.length > 0);
      // Leaf items wrap in <Link> so Cmd+Click / middle-click / 右鍵「新分頁開啟」
      // 走瀏覽器原生行為；母選單則保持純文字（Antd 點母選單是展開子層，不導航）。
      const labelNode = (
        <Tooltip title={labelText} placement="right" mouseEnterDelay={0.5}>
          <MenuLabel>{labelText}</MenuLabel>
        </Tooltip>
      );
      const menuItem: AntdMenuItem = {
        key: item.key,
        icon: item.icon ? React.createElement(item.icon) : null,
        label: hasChildren ? (
          labelNode
        ) : (
          <Link
            to={item.path}
            style={{ color: 'inherit', textDecoration: 'none', display: 'block' }}
          >
            {labelNode}
          </Link>
        ),
      };

      if (item.children) {
        menuItem.children = toAntdMenuItems(item.children, t);
      }

      return menuItem;
    })
    .filter((item) => {
      // 母選單若沒有任何可見子選單，整個隱藏
      const children = (item as AntdMenuItem).children;
      if (children) return children.length > 0;
      return true;
    });

export const createMenuItems = (
  t: TFunction,
  menuConfig: MenuItem[] = operatorMenuConfig,
): AntdMenuItems => toAntdMenuItems(menuConfig, t);

